// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	background-color: #fff !important;
}

/* .material-symbols-outlined{
	font-size: 14px !important;
} */
.btn-primary{
	background-color: #358696 !important;
    border-color: #358696 !important;
}
.aisMainDiv .btn-outline-primary{
	color:#358696 ;
	border-color:#358696;
}
.aisMainDiv .btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#358696;
	color:#fff;
}
.bg-white{
	background-color:#fff;
}
.aisMainDiv{
	margin-top:80px;
}
.aisFilterDiv {
    background: #e7e7e7;
}
.aisTitleChart {
    font-size: 0.8em;
    color: #0E3157;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
	border-radius: 5px 5px 0 0;
}
.aisChartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    color: #353535;
	min-height: 280px;
	border-radius: 5px;
}
.aisWd{
	min-height: 330px !important;
}
.aisChartHGT{
    padding: 10px;
}
.aisFilterForm > .form-label{
	font-size:0.825em;
}
.aisHeadfont{
	font-size:1.8rem;
}
.aistopRightDropMenu .dropdown-menu[data-bs-popper] {
    right:0 !important;
	left: auto;
}
.dropdownSelectBtnAIS{
	width: fit-content;
}

/*****************************  *******************************/


/*************************  *****************************/

/* media queries start here */

@media screen and (max-width: 720px) {

}

@media screen and (max-width: 480px) {

.aisHeadfont {
    font-size: 1rem;
}
}

.forDayError{
	margin-top: -12px !important;
}

.top-filterARAI {
	width: 100%;
	background: #fff;
	height: 37px;
	border: solid 1px #a5a5a5;
	border-radius: 3px;
	font-size: 14px;
	color: #353535;
	text-indent: 10px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Ais/aisCustom.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;AAClC;;AAEA;;GAEG;AACH;CACC,oCAAoC;IACjC,gCAAgC;AACpC;AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB,0BAA0B;AAC3B;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,cAAc;CACjB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,4BAA4B;AAC7B;AACA;IACI,aAAa;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;;AAEA,+DAA+D;;;AAG/D,yDAAyD;;AAEzD,6BAA6B;;AAE7B;;AAEA;;AAEA;;AAEA;IACI,eAAe;AACnB;AACA;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB","sourcesContent":["body {\n\tbackground-color: #fff !important;\n}\n\n/* .material-symbols-outlined{\n\tfont-size: 14px !important;\n} */\n.btn-primary{\n\tbackground-color: #358696 !important;\n    border-color: #358696 !important;\n}\n.aisMainDiv .btn-outline-primary{\n\tcolor:#358696 ;\n\tborder-color:#358696;\n}\n.aisMainDiv .btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\tbackground-color:#358696;\n\tcolor:#fff;\n}\n.bg-white{\n\tbackground-color:#fff;\n}\n.aisMainDiv{\n\tmargin-top:80px;\n}\n.aisFilterDiv {\n    background: #e7e7e7;\n}\n.aisTitleChart {\n    font-size: 0.8em;\n    color: #0E3157;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n\tborder-radius: 5px 5px 0 0;\n}\n.aisChartbox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    color: #353535;\n\tmin-height: 280px;\n\tborder-radius: 5px;\n}\n.aisWd{\n\tmin-height: 330px !important;\n}\n.aisChartHGT{\n    padding: 10px;\n}\n.aisFilterForm > .form-label{\n\tfont-size:0.825em;\n}\n.aisHeadfont{\n\tfont-size:1.8rem;\n}\n.aistopRightDropMenu .dropdown-menu[data-bs-popper] {\n    right:0 !important;\n\tleft: auto;\n}\n.dropdownSelectBtnAIS{\n\twidth: fit-content;\n}\n\n/*****************************  *******************************/\n\n\n/*************************  *****************************/\n\n/* media queries start here */\n\n@media screen and (max-width: 720px) {\n\n}\n\n@media screen and (max-width: 480px) {\n\n.aisHeadfont {\n    font-size: 1rem;\n}\n}\n\n.forDayError{\n\tmargin-top: -12px !important;\n}\n\n.top-filterARAI {\n\twidth: 100%;\n\tbackground: #fff;\n\theight: 37px;\n\tborder: solid 1px #a5a5a5;\n\tborder-radius: 3px;\n\tfont-size: 14px;\n\tcolor: #353535;\n\ttext-indent: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
